import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=43ddc3cd&scoped=true&"
import script from "@/scripts/QA/Question/components/Comment/Comment?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/Comment/Comment?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ddc3cd",
  null
  
)

export default component.exports